import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import bgUp from './assets/sectionBgUp.png';
import bgDown from './assets/sectionBgDown.png';

import style from './Section.module.less';

interface SectionProps {
  alternate?: boolean; // choose alternate, magenta color?
  straightTop?: boolean;
  straightBottom?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const Section: FunctionComponent<SectionProps> = props => (
  <section className={classnames(props.className, props.alternate && style.alternate)} style={{ ...props.style }}>
    {props.alternate && !props.straightTop && <div className={style.bgUp} style={{ backgroundImage: `url(${bgUp})` }} />}
    <div className={style.contentWrapper}>
      <div className={style.content}>
        {props.children}
      </div>
    </div>
    {props.alternate && !props.straightBottom && <div className={style.bgDown} style={{ backgroundImage: `url(${bgDown})` }} />}
  </section>
);
